"use client";

import clsx from "clsx";
import { useTranslations } from "@/lib/compat/i18n";
import { LtrToken } from "@/components/cdm/LtrToken";

const TOKEN: Record<string, string> = {
  "E":     "[E]",
  "I-AM":  "[I-AM]",
  "I-SV":  "[I-SV]",
  "E-GP":  "[E-GP]",
  "split": "[E ↔ I]",
};

const LABEL_KEY: Record<string, string> = {
  "E":     "auroraExporter",
  "I-AM":  "alMadarImporter",
  "I-SV":  "pampagroImporter",
  "E-GP":  "gulfPhosphateExporter",
  "split": "bothPerspectives",
};

/**
 * Top-end persona indicator (Decision 6 — keyboard-only swap, no visible
 * toggle, this glyph is the sole acknowledgement that we changed view).
 * Localised via next-intl; the bracketed perspective token stays LTR via
 * <LtrToken> so it reads correctly under RTL Arabic.
 */
export function PerspectiveGlyph({ perspective, className }: { perspective: string; className?: string }) {
  const t = useTranslations("perspectives");
  const labelKey = LABEL_KEY[perspective];
  const label = labelKey ? t(labelKey) : perspective;
  return (
    <div className={clsx("flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.18em] text-orbitra-muted", className)}>
      <span className="text-orbitra-teal-soft">
        <LtrToken mono={false}>{TOKEN[perspective] ?? perspective}</LtrToken>
      </span>
      <span className="text-orbitra-muted">·</span>
      <span>{label}</span>
    </div>
  );
}
